import React from 'react';
import * as styles from './ExternalServiceCard.module.scss';
import Badge from '../components/Badge';
import type { BrandAndProductProps } from '../components/ExternalBrandLogo';
import ExternalBrandLogo from '../components/ExternalBrandLogo';
import SettingCard from '../settings/SettingCard';

interface ExternalServiceCardProps {
  name: string;
  icon: BrandAndProductProps;
  action: React.ReactNode;
  details?: React.ReactNode;
  premium?: boolean;
}

const ExternalServiceCard = ({
  name,
  icon,
  action,
  details = null,
  premium = false,
}: ExternalServiceCardProps) => (
  <SettingCard
    actions={action}
    icon={<ExternalBrandLogo {...icon} height={24} />}
    description={
      <>
        {name}
        {!!premium && (
          <Badge className={styles.premiumBadge} color="yellow">
            Premium
          </Badge>
        )}
      </>
    }
    details={details}
  />
);

export default ExternalServiceCard;
